export const months = [
	'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October',
	'November', 'December'
]

export const years = [
	new Date().getFullYear(), new Date().getFullYear() - 1, new Date().getFullYear() - 2
]